import React, { useEffect, useState } from "react";
import { sensor } from "../../api";
import ConfirmationDlg from "../ConfirmationDlg";
import style from "./index.module.css";
import NormalInput from "../form/HorizontalNormalInput";

export const MachineElement = ({
  onUpdateElement,
  editMode,
  handleChange,
  defaultElements,
  handleDeletedElements,
  handleDeletedDeployments,
}) => {
  const [openSensor, setOpenSensor] = useState(false);
  const [selectedElement, setSelectedElement] = useState({});
  const [elementName, setElementName] = useState("");
  const [openEditElement, setOpenEditElement] = useState(false);
  const [openElement, setOpenElement] = useState(false);
  const [openNotifSensor, setOpenNotifSensor] = useState(false);
  const [openRemoveSensor, setOpenRemoveSensor] = useState(false);
  const [sensors, setSensors] = useState([]);
  const [selectedRemovedSensor, setSelectedRemovedSensor] = useState({});
  const [newElement, setNewElement] = useState({
    machine_element_name: "",
    sensors: [],
  });
  const [newSensor, setNewSensor] = useState({
    sensor_serial_number: "",
    sensor_mac_address: "",
  });
  const [indexSelectedElement, setIndexSelectedElement] = useState(null);

  const [elements, setElements] = useState(defaultElements);

  useEffect(() => {
    setElements(defaultElements);
  }, [defaultElements]);

  useEffect(() => {
    if (openSensor) {
      const getSensor = async () => {
        const result = await sensor.list();
        if (result.ok) {
          const body = await result.json();

          let sensors = body.data;
          let selectedSensors = [];
          elements.forEach((element) => {
            selectedSensors = [...selectedSensors, ...element.sensors];
          });
          sensors = sensors.filter(
            (s) =>
              !selectedSensors.some((ss) => ss.internal_id == s.internal_id)
          );

          sensors = sensors.map((s) => {
            return {
              ...s,
              internal_sensor_id: s.internal_id,
            };
          });

          setSensors(sensors);
        }
      };

      getSensor();
    }
  }, [openSensor]);

  const handleOpenSensor = (index) => {
    setIndexSelectedElement(index);
    setOpenSensor(true);
  };
  const handleCloseSensor = () => {
    setOpenSensor(false);
  };

  const handleOpenElement = () => {
    setOpenElement(true);
  };
  const handleCloseElement = () => {
    setOpenElement(false);
  };

  useEffect(() => {
    handleChange(elements);
  }, [JSON.stringify(elements)]);
  const handleSelectSensor = (sensor) => {
    setElements((prev) => {
      prev[indexSelectedElement].sensors.push(sensor);
      return prev;
    });
    setOpenSensor(false);
    setOpenNotifSensor(true);
  };

  const handleOnchange = (e) => {
    let key = e.target.name;

    setNewElement((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };

  const handleOnchangeSensor = (e) => {
    let key = e.target.name;

    setNewSensor((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };
  const handleAddElement = () => {
    if (!newElement.machine_element_name) return;

    setElements((prev) => [
      ...prev,
      { machine_element_name: newElement.machine_element_name, sensors: [] },
    ]);
    setOpenElement(false);
  };

  const handleAddSensor = async () => {
    if (!newSensor.sensor_serial_number || !newSensor.internal_id) return;

    const result = await sensor.create(newSensor);
    if (result.ok) {
      const body = await result.json();
      const newS = {
        ...newSensor,
        ...body.data,
      };
      setSensors((prev) => [...prev, newS]);
    }
  };

  const handleDeleteElement = (index, id) => {
    if (id) {
      const deployments = elements[index].sensors.map((s) => s.id);
      handleDeletedElements(id);
      handleDeletedDeployments(deployments);
    }
    setElements((prev) => prev.filter((p, pindex) => pindex != index));
  };

  const handleDeleteSensor = (indexSelectedElement, indexSensor, id) => {
    setSelectedRemovedSensor({
      indexSelectedElement,
      indexSensor,
      id,
    });
    setOpenRemoveSensor(true);
  };

  const submitDeleteSensor = () => {
    const { indexSelectedElement, indexSensor, id } = selectedRemovedSensor;
    const copy = [...elements];
    const sensors = copy[indexSelectedElement].sensors.filter(
      (s, sindex) => sindex != indexSensor
    );
    copy[indexSelectedElement].sensors = sensors;

    setElements(copy);
    if (id) {
      handleDeletedDeployments([id]);
    }
    setOpenRemoveSensor(false);
  };

  const handleChangeMachineElement = (e, index) => {
    const { value } = e.target;
    setElements((prev) => {
      prev[index].machine_element_name = value;
    });
  };

  const handleEditElement = (index, element) => {
    setElementName(element.machine_element_name);
    setSelectedElement(element);
    setOpenEditElement(true);
  };

  const closeElement = () => {
    setOpenEditElement(false);
    setSelectedElement({});
  };
  const handleUpdateElement = async () => {
    const result = await sensor.update(selectedElement.id, {
      machine_element_name: elementName,
    });
    if (result.ok) {
      const body = await result.json();
      setOpenEditElement(false);
      onUpdateElement();
    }
  };

  return (
    <>
      <ConfirmationDlg
        open={openEditElement}
        btnSubmitText={"Update"}
        btnCancelText={"Cancel"}
        onClose={closeElement}
        onSubmit={handleUpdateElement}
      >
        <h5>Change Machine Element Name</h5>
        <NormalInput
          full
          required={true}
          value={elementName}
          label="Machine Element"
          onchange={(e) => setElementName(e.target.value)}
          name="machine_element_name"
        />
      </ConfirmationDlg>
      <table className={style.tableMe} width={"100%"}>
        <thead>
          <tr>
            <td>Machine Element</td>
            <td>Sensor Added</td>
          </tr>
        </thead>
        <tbody>
          {elements.map((element, index) => {
            return (
              <tr key={index}>
                <td>
                  <div
                    style={{
                      display: "flex",

                      alignItems: "center",
                    }}
                  >
                    <p>{element.machine_element_name}</p>
                    <div
                      style={{
                        marginLeft: "auto",
                        display: "flex",
                      }}
                    >
                      {element.id && editMode && (
                        <button
                          className="btn"
                          style={{
                            cursor: "pointer",
                            width: "24px",
                            padding: "5px 4px",
                          }}
                          onClick={() => {
                            handleEditElement(index, element);
                          }}
                        >
                          <i className="fa fa-edit text-theme"></i>
                        </button>
                      )}

                      <button
                        className="btn"
                        style={{
                          cursor: "pointer",
                          width: "24px",
                          padding: "5px 4px",
                        }}
                        onClick={() => {
                          handleDeleteElement(index, element.id);
                        }}
                      >
                        <i className="fa fa-trash text-danger"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td align="center">
                  {element.sensors.map((sensor, indexSensor) => {
                    return (
                      <div
                        key={indexSensor}
                        style={{
                          display: "flex",

                          alignItems: "center",
                        }}
                      >
                        {sensor.sensor_serial_number}{" "}
                        <button
                          className="btn"
                          style={{
                            float: "right",
                            cursor: "pointer",
                            width: "24px",
                            marginLeft: "auto",
                            padding: "5px 4px",
                          }}
                          onClick={() => {
                            handleDeleteSensor(index, indexSensor, sensor.id);
                          }}
                        >
                          <i className="fa fa-trash text-danger"></i>
                        </button>
                      </div>
                    );
                  })}

                  <div
                    onClick={() => handleOpenSensor(index)}
                    style={{
                      cursor: "pointer",
                      fontSize: "12px",
                      lineHeight: "12px",
                      verticalAlign: "middle",
                      display: "flex",
                      marginTop: "10px",

                      width: "100%",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    className="text-theme"
                  >
                    <i className="fa fa-plus"></i>
                    <span
                      style={{
                        padding: "4px 10px",
                      }}
                    >
                      Add Sensor{" "}
                    </span>
                  </div>
                </td>
              </tr>
            );
          })}

          <tr>
            <td align="center" colSpan={2}>
              <div
                onClick={handleOpenElement}
                style={{
                  cursor: "pointer",
                  fontSize: "12px",
                  lineHeight: "12px",
                  verticalAlign: "middle",
                  display: "flex",

                  alignItems: "center",
                  justifyContent: "center",
                }}
                className="text-theme"
              >
                <i className="fa fa-plus"></i>
                <span style={{ padding: "4px 10px" }}>
                  Add Machine Element{" "}
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <ConfirmationDlg
        open={openSensor}
        onClose={handleCloseSensor}
        onSubmit={handleAddSensor}
        type="alert"
        title={"Add Sensor"}
        btnSubmitText={"Add"}
      >
        <div
          style={{ width: 360, margin: "0 auto", pb: 3, textAlign: "center" }}
        >
          {sensors.length == 0 && "No Sensor Available"}
          {sensors.map((sensor, index) => {
            return (
              <div
                style={{
                  cursor: "pointer",
                  border: "1px solid #555",
                  textAlign: "center",
                }}
                className="p-1 mb-1"
                key={index}
                onClick={() => handleSelectSensor(sensor)}
              >
                {sensor.sensor_serial_number || "(undefined)"}
              </div>
            );
          })}
        </div>
      </ConfirmationDlg>

      <ConfirmationDlg
        open={openNotifSensor}
        onClose={() => setOpenNotifSensor(false)}
        onSubmit={() => setOpenNotifSensor(false)}
        type="confirmation"
        hideCancelBtn
        title={"Add Sensor"}
        btnSubmitText={"Ok"}
      >
        <div
          style={{
            width: 360,
            margin: "0 auto",
            pb: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <i className="fa fa-alert"></i>
          <p style={{ textAlign: "left" }}>
            Do note that it will take approximately 15 minutes for the newly
            added sensor data to appear on the dashboard.
          </p>
        </div>
      </ConfirmationDlg>

      <ConfirmationDlg
        open={openRemoveSensor}
        onClose={() => setOpenRemoveSensor(false)}
        onSubmit={() => submitDeleteSensor()}
        type="confirmation"
        title={"Remove Sensor"}
        btnSubmitText={"YES"}
        btnCancelText={"NO"}
      >
        <div
          style={{
            width: 360,
            margin: "0 auto",
            pb: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <i className="fa fa-alert"></i>
          <p style={{ textAlign: "left" }}>
            Are you sure want to remove this sensor?
          </p>
        </div>
      </ConfirmationDlg>

      <ConfirmationDlg
        onClose={handleCloseElement}
        open={openElement}
        onSubmit={handleAddElement}
        title={"Add Machine Element"}
        type="submit"
      >
        <div
          sx={{
            width: "70%",
            textAlign: "center",

            margin: "0 auto",
            pb: 2,
          }}
        >
          <NormalInput
            full
            required={true}
            value={newElement["machine_element_name"]}
            label="Machine Element"
            onchange={handleOnchange}
            name="machine_element_name"
          />
        </div>
      </ConfirmationDlg>
    </>
  );
};
